module.exports = __webpack_public_path__ + "static/media/product_4.04a91c41.png";